module.exports = __webpack_public_path__ + "img/837af55.jpg";